export const ACTIONS = {
  SIGNUP: 'ae-duda-signup-btn',
  LOGIN: 'ae-duda-login-btn',
  LOGOUT: 'ae-duda-logout-btn',
  CHECKOUT: 'ae-duda-checkout-btn',
  MY_ACCOUNT: 'ae-duda-account-btn',
}
